import { render, staticRenderFns } from "./FleetEvents.vue?vue&type=template&id=40b55f52"
import script from "./FleetEvents.vue?vue&type=script&lang=js"
export * from "./FleetEvents.vue?vue&type=script&lang=js"
import style0 from "./FleetEvents.vue?vue&type=style&index=0&id=40b55f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports